import React, { createContext, useRef, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import SceneManager from "./BabylonSceneManager";

const SceneContext = createContext(null);

export function BabylonSceneProvider({ children }) {
    const dispatch = useDispatch();
    const managerRef = useRef(null);
    if (managerRef.current === null) {
        managerRef.current = new SceneManager();
    }

    useEffect(
        () => () => {
            managerRef.current.dispose();
        },
        []
    );

    useEffect(() => {
        managerRef.current.attachDispatch(dispatch);
        return () => managerRef.current.dispose();
    }, [dispatch]);

    return <SceneContext.Provider value={managerRef.current}>{children}</SceneContext.Provider>;
}

export function useScene() {
    const mgr = useContext(SceneContext);
    if (!mgr) throw new Error("useScene must be inside <BabylonSceneProvider>");
    return mgr;
}
